module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("6a0gm"))).then(() => parcelRequire('2mD4j'));